import { Button } from "../../components/Button";
import { ApiError, serverBesked } from "../../lib/customFetch";
import styles from "./admin.module.css";

export type AdminProblemKind = "validation" | "conflict" | "unavailable";

export interface AdminProblemValue {
  kind: AdminProblemKind;
  title: string;
  description: string;
}

/**
 * Ens ordlyd på chefens dag-, uge-, rettelses- og godkendelsesflader.
 * 4xx kan rettes i de viste data, 409 kræver at den nyere tilstand håndteres,
 * mens netværk/5xx kan genforsøges uden at formularens lokale state ryddes.
 */
export function beskrivAdminProblem(
  error: unknown,
  handling: string,
  bevarerInput = false,
): AdminProblemValue {
  if (error instanceof ApiError && error.status === 409) {
    const besked = serverBesked(error);
    return {
      kind: "conflict",
      title: "Data har ændret sig",
      description:
        besked ??
        `Kunne ikke ${handling}, fordi data er ændret. Opdatér visningen, før du prøver igen.`,
    };
  }

  if (
    error instanceof ApiError &&
    (error.status === 401 || error.status === 403)
  ) {
    return {
      kind: "validation",
      title: "Du har ikke adgang",
      description:
        serverBesked(error) ??
        `Du har ikke adgang til at ${handling}. Log ind igen, hvis du er blevet logget ud.`,
    };
  }

  if (
    error instanceof ApiError &&
    error.status >= 400 &&
    error.status < 500
  ) {
    const besked = serverBesked(error);
    return {
      kind: "validation",
      title: "Tjek oplysningerne",
      description:
        besked ?? `Kunne ikke ${handling}. Ret oplysningerne og prøv igen.`,
    };
  }

  return {
    kind: "unavailable",
    title: "Forbindelsen svigtede",
    description: `Kunne ikke ${handling}. ${
      bevarerInput ? "Dine indtastninger er bevaret. " : ""
    }Tjek forbindelsen og prøv igen.`,
  };
}

export function lokaltValideringsproblem(besked: string): AdminProblemValue {
  return {
    kind: "validation",
    title: "Tjek oplysningerne",
    description: besked,
  };
}

export function AdminProblem({
  problem,
  onAction,
  actionLabel = "Prøv igen",
}: {
  problem: AdminProblemValue;
  onAction?: () => void;
  actionLabel?: string;
}) {
  return (
    <div
      className={`${styles.problem} ${styles[`problem_${problem.kind}`] ?? ""}`}
      role="alert"
    >
      <div className={styles.problemTekst}>
        <strong>{problem.title}</strong>
        <span>{problem.description}</span>
      </div>
      {onAction !== undefined && (
        <Button variant="secondary" onClick={onAction}>
          {actionLabel}
        </Button>
      )}
    </div>
  );
}
